import { PaymentApi, TransactionApi, ReceiptApi, OrderPaymentRequestData } from 'common/types';
import { newFirestoreId } from 'common/utils/dataMigrations';
import { FieldValues, BatchManager } from 'common/frontend/firebase/firestore';
import { api } from 'common/frontend/api';

export const saveOrderPaymentInfo = async (
	paymentData: { payment: PaymentApi; transactions: TransactionApi[]; receipt: ReceiptApi },
	orderPaymentRequestData: OrderPaymentRequestData,
) => {
	const { amount, orderId, paymentNumber } = orderPaymentRequestData;
	const { payment, transactions, receipt } = paymentData;
	const batchManager = new BatchManager();
	api(batchManager.batch()).payments.doc(payment.id).set(payment);
	for (const transaction of transactions) {
		api(batchManager.batch()).transactions.doc(transaction.id).set(transaction);
	}
	api(batchManager.batch()).receipts.doc(receipt.id).set(receipt);
	api(batchManager.batch())
		.orders.doc(orderId)
		.update({
			'charge.paid': FieldValues.increment(amount.value),
			'charge.captured': FieldValues.increment(amount.value),
			'charge.authorised': FieldValues.increment(amount.value),
		});
	for (const item of payment.items) {
		const {
			pricing: { total },
			productId,
			deliveryId,
		} = item;
		if (!total || !productId) {
			continue;
		}
		if (!!deliveryId && !!item.pricing.total) {
			api(batchManager.batch())
				.orderDeliveries.doc(deliveryId)
				.update({
					'charge.paid': FieldValues.increment(item.pricing.total),
					'charge.captured': FieldValues.increment(item.pricing.total),
					'charge.authorised': FieldValues.increment(item.pricing.total),
				});
		}
		api(batchManager.batch())
			.orderProducts.doc(productId)
			.update({
				'charge.paid': FieldValues.increment(total),
				'charge.captured': FieldValues.increment(total),
				'charge.authorised': FieldValues.increment(total),
			});
	}
	const requestId = orderPaymentRequestData.id ?? newFirestoreId();
	if (paymentNumber != null) {
		api(batchManager.batch())
			.orders.doc(orderId)
			.orderPaymentRequests.doc(requestId)
			.set({
				...orderPaymentRequestData,
				id: requestId,
				paymentNumber,
				paid: true,
				paymentAction: 'PAYMENT',
			});
	}
	await batchManager.commit();
};

export const saveOrderDepositInfo = async (
	paymentData: { payment: PaymentApi; transactions: TransactionApi[]; receipt: ReceiptApi },
	orderPaymentRequestData: OrderPaymentRequestData,
) => {
	const { amount, paymentNumber, orderId } = orderPaymentRequestData;
	const { payment, transactions, receipt } = paymentData;
	const batchManager = new BatchManager();
	api(batchManager.batch()).payments.doc(payment.id).set(payment);
	for (const transaction of transactions) {
		api(batchManager.batch()).transactions.doc(transaction.id).set(transaction);
	}
	api(batchManager.batch()).receipts.doc(receipt.id).set(receipt);
	api(batchManager.batch())
		.orders.doc(orderId)
		.update({
			'deposit.authorised': FieldValues.increment(amount.value),
		});
	const requestId = orderPaymentRequestData.id ?? newFirestoreId();
	if (paymentNumber != null) {
		api(batchManager.batch())
			.orders.doc(orderId)
			.orderPaymentRequests.doc(requestId)
			.set({
				...orderPaymentRequestData,
				id: requestId,
				paymentNumber,
				paid: true,
				paymentAction: 'AUTHORISATION',
			});
	}
	await batchManager.commit();
};
